<gbc-page-container>
  <gbc-tile>
    <div style="padding: 2em">
      <h2>{{ 'account-page.subscription-differences' | translate }}</h2>
      <button gbc-button [routerLink]="['/account', 'mixit-subscriptions-overview']">
        {{ 'account-page.learn-more' | translate }}
      </button>
    </div>
  </gbc-tile>

  <gbc-tile [title]="'app-account-page.licensing' | translate">
    <gbc-table>
      <th gbc-table-header>{{ 'account-page.device-table.facility' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.device' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.active-upgrade' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.serial-number' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.license-type' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.purchase-date' | translate }}</th>
      <th gbc-table-header>{{ 'account-page.device-table.renewal-date' | translate }}</th>
      @for (facility of mixitFacilities$ | async; track facility) {
        @for (installation of facility.installations; track installation) {
          @if (installation) {
            @if (getLatest(installation.licenseInformation); as licenses) {
              <tr gbc-table-row>
                <td gbc-table-cell>{{ facility.name }}</td>
                <td gbc-table-cell>
                  <span class="installation-name">
                    <app-mixit-connection-status [installation]="installation"></app-mixit-connection-status>
                    <span class="name" title="{{ installation.name }}">{{ installation.name }}</span>
                  </span>
                  @if (installation.parentInstallation) {
                    <span>({{ installation.parentInstallation.name }})</span>
                  }
                </td>
                <td gbc-table-cell>
                  @if (getSomeActivePaid(licenses)) {
                    @for (license of licenses; track license) {
                      <span class="block">
                        @if (license.isConnect) {
                          {{ 'schematic.connect' | translate }}
                        }
                        @if (license.isDynamic) {
                          {{ 'schematic.dynamic' | translate }}
                        }
                      </span>
                    }
                  } @else {
                    <span class="block">{{ 'schematic.freemium' | translate }}</span>
                  }
                </td>
                <td gbc-table-cell>{{ installation.serialNumber }}</td>
                <td gbc-table-cell>
                  @if (getSomeActivePaid(licenses)) {
                    @for (license of licenses; track license) {
                      @if (license.isActive) {
                        <span class="block">{{ 'license.type.' + getLicenseType(license) | translate }}</span>
                      }
                    }
                  } @else {
                    <span class="block">{{ 'license.type.free' | translate }}</span>
                  }
                </td>
                <td gbc-table-cell>
                  @if (getSomeActivePaid(licenses)) {
                    @for (license of licenses; track license) {
                      @if (license.isActive) {
                        <span class="block">{{ license?.activationTimeEpoch | date }}</span>
                      }
                    }
                  } @else {
                    <span class="block">&#8212;</span>
                  }
                </td>
                <td gbc-table-cell>
                  @if (getSomeActivePaid(licenses)) {
                    @for (license of licenses; track license) {
                      @if (license.isActive && (license.isSubscription || license.isTrial)) {
                        <span class="block">{{
                          license?.expirationTimeEpoch | date
                        }}</span>
                      }
                      @if (license.isActive && license.isOneTimeFee) {
                        <span class="block">&#8212;</span>
                      }
                    }
                  } @else {
                    <span class="block">&#8212;</span>
                  }
                </td>
              </tr>
            }
          }
        }
      }
    </gbc-table>
    <div gbc-tile-right>
      <button gbc-button small [routerLink]="'/upgrade/subscribe/'">{{ 'account-page.upgrade-button' | translate }}</button>
    </div>
  </gbc-tile>
</gbc-page-container>



